import { createSelector, createEntityAdapter } from '@reduxjs/toolkit';
import { apiSlice } from '../../app/api/apiSlice';

const blogPostsAdapter = createEntityAdapter({});

const initialState = blogPostsAdapter.getInitialState();

export const blogPostsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getBlogPosts: builder.query({
            query: () => '/blogposts',
            // ... (other code remains the same)
        }),
        getBlogPostById: builder.query({
            query: (id) => `/blogposts/${id}`,
            // ... (other code remains the same)
        }),
        addNewBlogPost: builder.mutation({
            query: (initialBlogPostData) => ({
                url: '/blogposts',
                method: 'POST',
                body: {
                    ...initialBlogPostData,
                },
            }),
            // ... (other code remains the same)
        }),
        updateBlogPost: builder.mutation({
            query: (initialBlogPostData) => ({
                url: `/blogposts/${initialBlogPostData.id}`,
                method: 'PUT',
                body: {
                    ...initialBlogPostData,
                },
            }),
            // ... (other code remains the same)
        }),
        deleteBlogPost: builder.mutation({
            query: ({ id }) => ({
                url: `/blogposts/${id}`,
                method: 'DELETE',
            }),
            // ... (other code remains the same)
        }),
    }),
});

export const {
    useGetBlogPostsQuery,
    useAddNewBlogPostMutation,
    useUpdateBlogPostMutation,
    useDeleteBlogPostMutation,
} = blogPostsApiSlice;

// returns the query result object
export const selectBlogPostsResult = blogPostsApiSlice.endpoints.getBlogPosts.select();

// creates memoized selector
const selectBlogPostsData = createSelector(
    selectBlogPostsResult,
    blogPostsResult => blogPostsResult.data // normalized state object with ids & entities
);

// getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllBlogPosts,
    selectById: selectBlogPostById,
    selectIds: selectBlogPostIds,
    // Pass in a selector that returns the blog posts slice of state
} = blogPostsAdapter.getSelectors(state => selectBlogPostsData(state) ?? initialState);
